import { useState } from "react";
import { Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { formatLeft } from "../lib/api";
import { clusterSpots } from "../lib/geo";

const spotIcon = (spot, now) => {
  const cls = spot.is_mine ? "mine" : spot.reserved_by_me ? "active" : spot.status;
  const text = spot.reserved_by_me ? `Tuo · ${formatLeft(spot.leave_at, now)}` : spot.status === "reserved" && !spot.is_mine ? "Prenotato" : formatLeft(spot.leave_at, now);
  return L.divIcon({ className: "spot-pin", html: `<div class="pill ${cls}">P · ${text}</div>`, iconSize: [0, 0] });
};

const clusterIcon = (spots) => {
  const free = spots.filter((s) => s.status === "active" && !s.is_mine).length;
  return L.divIcon({
    className: "spot-pin",
    html: `<div class="cluster" data-testid="spot-cluster"><b>${spots.length}</b><span>posti${free ? ` · ${free} liberi` : ""}</span></div>`,
    iconSize: [0, 0],
  });
};

export const SpotMarkers = ({ spots, now, onSelect, onSelectGroup }) => {
  const map = useMap();
  const [, setTick] = useState(0);
  useMapEvents({ zoomend: () => setTick((t) => t + 1) });

  const openCluster = (group) => {
    const bounds = L.latLngBounds(group.spots.map((s) => [s.lat, s.lng]));
    const targetZoom = Math.min(map.getBoundsZoom(bounds.pad(0.5)), 19);
    if (targetZoom > map.getZoom() && map.getZoom() < 18) map.flyToBounds(bounds.pad(0.5), { maxZoom: 19 });
    else onSelectGroup(group.spots);
  };

  return clusterSpots(spots, map).map((g) =>
    g.spots.length === 1 ? (
      <Marker key={g.spots[0].id} position={[g.lat, g.lng]} icon={spotIcon(g.spots[0], now)} zIndexOffset={1000} eventHandlers={{ click: () => onSelect?.(g.spots[0]) }} />
    ) : (
      <Marker key={g.spots.map((s) => s.id).join("-")} position={[g.lat, g.lng]} icon={clusterIcon(g.spots)} zIndexOffset={1000} eventHandlers={{ click: () => openCluster(g) }} />
    ),
  );
};
